// Single source of truth for the backend origin.
// It was previously repeated inline in ~60 places, which made the
// host impossible to change and easy to typo.
export const API_BASE = 'https://backend.bansalattire.com';

/** Build an absolute API endpoint from a path such as `/api/category`. */
export const apiUrl = (path) => `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;

/**
 * Resolve a media path returned by the backend into a full URL.
 * Returns null for empty values so callers can skip rendering the
 * <img> entirely instead of requesting `https://.../undefined`.
 */
export const mediaUrl = (path) => {
  if (!path || typeof path !== 'string') return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}/${path.replace(/^\/+/, '')}`;
};
